import axios from "axios"

interface ApiErrorBody {
  // Result failures from handlers: { error, code }
  error?: string
  // Exceptions handled by the global middleware: { type, message }
  message?: string
}

/** The API's error text (Result `error` or middleware `message`), else the error's own message, else the fallback. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const body = error.response?.data as ApiErrorBody | undefined
    const message = body?.error ?? body?.message
    if (message) return message
  }
  return error instanceof Error && error.message ? error.message : fallback
}
